var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.055,
    height: 21.055,
    viewBox: "0 0 21.055 21.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_561",
    "data-name": "Trac\\xE9 561",
    d: "M18.969,16.235A2.735,2.735,0,1,1,16.235,13.5,2.735,2.735,0,0,1,18.969,16.235Z",
    transform: "translate(-4.707 -4.707)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_562",
    "data-name": "Trac\\xE9 562",
    d: "M18.273,14.262a1.5,1.5,0,0,0,.3,1.659l.055.055a1.824,1.824,0,1,1-2.58,2.58l-.055-.055a1.516,1.516,0,0,0-2.571,1.076v.155a1.823,1.823,0,0,1-3.646,0v-.082a1.5,1.5,0,0,0-.985-1.376,1.5,1.5,0,0,0-1.659.3l-.055.055a1.824,1.824,0,1,1-2.58-2.58l.055-.055a1.516,1.516,0,0,0-1.076-2.571H3.323a1.823,1.823,0,1,1,0-3.646h.082a1.5,1.5,0,0,0,1.376-.985,1.5,1.5,0,0,0-.3-1.659l-.055-.055A1.824,1.824,0,1,1,7.006,4.5l.055.055a1.5,1.5,0,0,0,1.659.3h.073A1.5,1.5,0,0,0,9.7,3.478V3.323a1.823,1.823,0,0,1,3.646,0v.082a1.516,1.516,0,0,0,2.571,1.076l.055-.055a1.824,1.824,0,1,1,2.58,2.58l-.055.055a1.5,1.5,0,0,0-.3,1.659v.073a1.5,1.5,0,0,0,1.376.912h.155a1.823,1.823,0,0,1,0,3.646h-.082a1.5,1.5,0,0,0-1.376.912Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParams);
export default __webpack_public_path__ + "static/media/params.7622cb32b75f629e89cf5a1a331a6dfb.svg";
export { ForwardRef as ReactComponent };